<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>photo_library</md-icon>
          </div>
          <h4 class="title">Wingio Product Images</h4>
        </md-card-header>

        <md-card-content>
            <h3 class="product-title" v-if="produtDetail">{{ produtDetail.name }}</h3>
          <!-- 🔁 Display Images -->
          <div class="image-gallery">
            <!-- Image thumbnails -->
            <div v-for="(img, index) in productImages" :key="index" class="image-wrapper">
                <img :src="img.productImage" class="image-preview" @click="openImage(img.productImage)" style="cursor: pointer" />
                <a href="javascript:void(0)" @click="deleteImage(img._id)"><md-icon class="delete-icon">delete</md-icon></a>
            </div>
          </div>

          <!-- ⬆️ Drag & Drop Upload -->
          <div
            class="upload-area"
            @dragover.prevent
            @drop.prevent="handleDrop"
            @click="triggerFileInput"
        >
            <md-icon>cloud_upload</md-icon>
            <p>Drag & Drop or Click to Upload</p>
            <input
            type="file"
            ref="fileInput"
            multiple
            accept="image/*"
            @change="handleFileChange"
            style="display: none"
            />
        </div>

          <div v-if="showPreview" class="image-modal" @click.self="closePreview">
  <div class="image-modal-content">
    <span class="close-btn" @click="closePreview">&times;</span>
    <img :src="selectedImage" class="preview-image" />
  </div>
</div>


        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import OrdersDataService from "../../services/SuperAdmin/Kids/OrdersDataService";

export default {
  components: {
    
  },
  data() {
    return {
        productdId: this.$route.query.id,
        productImages: [],
        showPreview: false,      // Controls modal visibility
        selectedImage: null ,
        produtDetail: null,
    };
  },
  methods: {
    getWingioProductImages() {
        OrdersDataService.getWingioProductImages({ id: this.productdId })
          .then((response) => {
            this.productImages = response.data.data;
            this.produtDetail = response.data.produtDetail
          })
          .catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
          });
    },
    deleteImage(id) {
      OrdersDataService.deleteWingioProductImages({ id: id })
        .then((response) => {
            this.$toast.success(response.data.respones_msg);
            this.getWingioProductImages()
        })
        .catch((e) => {
        this.$toast.error(e.response.data.respones_msg);
    });
    },
    openImage(img) {
        this.selectedImage = img;
        this.showPreview = true;
    },
    closePreview() {
      this.showPreview = false;
      this.selectedImage = null;
      this.removeEscapeListener();
    },
    handleEscape(event) {
      if (event.key === 'Escape') {
        this.closePreview();
      }
    },
    addEscapeListener() {
      document.addEventListener('keydown', this.handleEscape);
    },
    removeEscapeListener() {
      document.removeEventListener('keydown', this.handleEscape);
    },
    triggerFileInput() {
        this.$refs.fileInput.click();
    },

  handleFileChange(e) {
    const files = Array.from(e.target.files);
    this.previewSelectedImages(files);
    e.target.value = ""; // Reset input for future uploads
  },

  handleDrop(e) {
    const files = Array.from(e.dataTransfer.files);
    this.previewSelectedImages(files);
  },

  previewSelectedImages(files) {
    const imageFiles = files.filter(file => file.type.startsWith("image/"));
    if (imageFiles.length === 0) return;

    const formData = new FormData();
    formData.append("productId", this.productdId);

    imageFiles.forEach(file => {
        formData.append("images[]", file); // Append each file to the array
    });

    OrdersDataService.uploadWingioProductImages(formData)
        .then(() => {
            this.$toast.success("Images uploaded successfully!");
            this.getWingioProductImages(); // Refresh after upload
        })
        .catch((err) => {
            this.$toast.error("Upload failed: " + (err.response?.data?.message || err.message));
        });
    }
  },
  watch: {
    showPreview(newVal) {
      if (newVal) {
        this.addEscapeListener();
      } else {
        this.removeEscapeListener();
      }
    },
  },
  beforeMount() {
    this.getWingioProductImages()
    this.removeEscapeListener();
  },
};
</script>

<style scoped>
.image-gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 20px;
}

.image-wrapper {
  position: relative;
  width: 120px;
  height: 120px;
  border: 1px solid #ccc;
  border-radius: 4px;
  overflow: hidden;
}

.image-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.delete-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(255, 0, 0, 0.8);
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  padding: 4px;
}

.upload-area {
  border: 2px dashed #4caf50;
  border-radius: 6px;
  text-align: center;
  padding: 30px;
  cursor: pointer;
  color: #666;
  transition: background 0.3s;
}

.upload-area:hover {
  background: #f4fff4;
}

.image-gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 120px;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 10px;
  background: #fff;
  transition: box-shadow 0.2s ease;
}

.image-wrapper:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.image-preview {
  width: 100%;
  height: 100px;
  object-fit: cover;
  border-radius: 4px;
}

.delete-icon {
  position: absolute;
  bottom: 6px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 20px;
  color: #f44336 !important;
  background: white;
  border-radius: 50%;
  padding: 2px;
  cursor: pointer;
  transition: color 0.2s ease, transform 0.2s ease;
  z-index: 2;
}

.delete-icon:hover {
  color: #d32f2f;
  transform: translateX(-50%) scale(1.1);
}
.image-modal {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
  box-sizing: border-box;
}

.image-modal-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
}

.preview-image {
  width: 100%;
  height: auto;
  max-height: 80vh;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.5);
}

.close-btn {
  position: absolute;
  top: -30px;
  right: -30px;
  font-size: 3rem;
  color: white;
  cursor: pointer;
  z-index: 10000;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 50%;
  padding: 5px 10px;
  line-height: 1;
}

</style>
